import apiClient from '@/services/AccountClient'

const state = () => ({
  primaryFeeGroups: [],
  primaryFeeGroupsLoaded: false
})

const getters = {
  primaryFeeGroups: (state) => {
    return state.primaryFeeGroups
  },
  primaryFeeGroupsLoaded: (state) => {
    return state.primaryFeeGroupsLoaded
  }
}

const actions = {
  loadPrimaryFeeGroups ({ commit }) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/fees/groups/primary'
    )
      .then(({ payload }) => {
        commit('setPrimaryFeeGroups', payload)
        commit('setPrimaryFeeGroupsLoaded')
      })
  }
}

const mutations = {
  setPrimaryFeeGroups (state, primaryFeeGroups) {
    state.primaryFeeGroups = primaryFeeGroups
  },
  setPrimaryFeeGroupsLoaded (state) {
    state.primaryFeeGroupsLoaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
